import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { Modal } from 'containers/misc'
import {
  AjPEventChangeAim as AjPEventChangeAimForm
} from 'containers/forms/aj-events'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import styles from './ajpe-event-change-aim.styl'

export default class AjPEventChangeAim extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    changeAjParticipantEventGoal: PropTypes.func.isRequired
  }
  static defaultProps = {
    data: {}
  }

  key = uuid.v1()

  render() {
    const { data } = this.props

    return (
      <div>
        <Title h4>
          <strong>Aim</strong>
        </Title>
        <div className={styles.eventRow}>
          <div className={styles.aim}>
            {data.aim}
          </div>
          <div className={styles.action}>
            <Button
              type="button"
              tiny
              secondary
              intlKey="button.change_goal"
              onClick={() =>
                this.props.modal(`modal-ajpe-change-goal-${this.key}`)}
            >
              Change goal
            </Button>
          </div>
        </div>
        <Modal id={`modal-ajpe-change-goal-${this.key}`} customActions>
          <AjPEventChangeAimForm
            data={data}
            changeAjParticipantEventGoal={
              this.props.changeAjParticipantEventGoal
            }
          />
        </Modal>
      </div>
    )
  }
}
